import { http } from "../helpers/easyindustriaapi/config";

export default class AtendimentoController {
    constructor() {
        this.currentUser = JSON.parse(localStorage.getItem('user'));
        this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'));
    }

    async getValidations(params = {}) {
        // Processa agreements: se for array, extrai os IDs
        let agreement_ids = null
        if (params.agreements && Array.isArray(params.agreements) && params.agreements.length > 0) {
            agreement_ids = params.agreements.map((agreement) => agreement.id || agreement).filter(Boolean)
        }

        const parameters = {
            professional_id: (params.professional && params.professional.id) ? params.professional.id : null,
            pacient_id: (params.patient && params.patient.id) ? params.patient.id : null,
            agreement_ids: agreement_ids,
            date_ini: params.date_ini || null,
            date_end: params.date_end || null,
            empresa_id: this.currentEmpresa?.id,
            page: params.page || 1,
            per_page: params.per_page || 15,
            sort: params.sort || null,
            is_billed: params.is_billed === 'all' ? null : params.is_billed,
            is_cancelled: params.is_cancelled === 'all' ? null : params.is_cancelled,
        }

        try {
            const response = await http.get(`/atendimento/validations`, { params: parameters })
            return response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    /**
     * Limpa e converte valor formatado (BR) para número válido
     * Remove espaços, pontos de milhar e converte vírgula para ponto
     */
    cleanFormattedValue(value) {
        if (value === null || value === undefined || value === '') return null
        
        // Converte para string e remove todos os tipos de espaços (incluindo não quebráveis)
        let cleaned = String(value)
            .replace(/\s+/g, '') // Remove todos os espaços (incluindo múltiplos)
            .replace(/\u00A0/g, '') // Remove espaços não quebráveis
            .replace(/\u2000-\u200B/g, '') // Remove vários tipos de espaços Unicode
            .trim() // Remove espaços no início e fim
        
        // Remove pontos de milhar e converte vírgula para ponto decimal
        // Primeiro remove pontos (que são separadores de milhar no formato BR)
        // Depois converte vírgula para ponto (separador decimal)
        cleaned = cleaned.replace(/\./g, '') // Remove pontos (milhar)
        cleaned = cleaned.replace(',', '.') // Converte vírgula para ponto decimal
        
        // Verifica se é um número válido
        const numericValue = parseFloat(cleaned)
        if (isNaN(numericValue) || !isFinite(numericValue)) {
            return null
        }
        
        return numericValue
    }

    async markBilled(recurrenceIds = [], contaPagar = null) {
        const payloadContaPagar = { ...(contaPagar || {}) }
        if (!payloadContaPagar.professional_id) {
            throw new Error('É obrigatório selecionar exatamente um profissional para faturar.')
        }

        // Limpa o valor formatado antes de enviar
        if (payloadContaPagar.valorPagar) {
            const cleanedValue = this.cleanFormattedValue(payloadContaPagar.valorPagar)
            if (cleanedValue === null) {
                throw new Error('O valor a pagar está em formato inválido. Por favor, informe um número válido.')
            }
            payloadContaPagar.valorPagar = cleanedValue
        }
        
        const payload = { ids: recurrenceIds, empresa_id: this.currentEmpresa?.id, conta_pagar: payloadContaPagar }
        
        try {
            const response = await http.put(`/atendimento/validations/bill`, payload)
            return response.data
        } catch (error) {
            // Extrai mensagem de erro do backend se disponível
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error)
            }
            throw this.handleError(error)
        }
    }

    async unmarkBilled(recurrenceIds = [], contaPagar = null) {
        const payload = { ids: recurrenceIds, empresa_id: this.currentEmpresa?.id, conta_pagar: contaPagar }
        const response = await http.put(`/atendimento/validations/unbill`, payload)
        return response.data
    }

    async cancelRecurrences(recurrenceIds = []) {
        const payload = { ids: recurrenceIds, empresa_id: this.currentEmpresa?.id }
        const response = await http.put(`/atendimento/validations/cancel`, payload)
        return response.data
    }

    async reactivateRecurrences(recurrenceIds = []) {
        const payload = { ids: recurrenceIds, empresa_id: this.currentEmpresa?.id }
        const response = await http.put(`/atendimento/validations/reactivate`, payload)
        return response.data
    }

    doGet(params) {
        localStorage.setItem('atendimentos_params', JSON.stringify(params));
        console.log(params);
        const promisse = http.get(`/atendimento/byEmpresa/${this.currentEmpresa.id}`, {
             params: { ...params }
        })
        return promisse.then((response) => {
            return response
        })
    }

    doGetTable(params) {
        const promisse = http.get(`/atendimento/tabelas?empresa_id=${this.currentEmpresa.id}`, {
            params: { ...params }
        })
        return promisse.then((response) => {
            return response
        })
    }

    doPost(atendimento) {
        atendimento.empresa_id = this.currentEmpresa.id;
        const promisse = http.post(`/atendimento?empresa_id=${this.currentEmpresa.id}`, atendimento)
        return promisse.then((response) => {
            return response
        })
    }

    doPostLote(payload) {
        const body = {
            paciente_id: payload.paciente_id,
            observacao: payload.observacao || null,
            agendas: payload.agendas,
        }
        if (payload.empresa_id) body.empresa_id = payload.empresa_id
        return http.post('/atendimento/lote', body).then((response) => response)
    }

    getFiles(atendimento) {
        const promisse = http.get(`/atendimento/${atendimento.id}/arquivos/?empresa_id=${this.currentEmpresa.id}`)
        return promisse.then((response) => {
            const items = response.data.data
            return items || []
        }).catch((error) => {
            console.log(error)
            throw this.handleError(error)
        })
    }

    async uploadFile(file, atendimento) {
        try {
            const formData = new FormData()
            formData.append("file", file)
            const headers = { 'Content-Type': 'multipart/form-data' }
            const response = await http.post(
                `/atendimento/${atendimento.id}/upload/?empresa_id=${this.currentEmpresa.id}`, 
                formData,
                { headers }
            )
            return response.data
        } catch (error) {
            console.log(error)
            throw this.handleError(error)
        }
    }

    async delete(id) {
        try {
            const response = await http.delete(`/arquivo/${id}?empresa_id=${this.currentEmpresa.id}`)
            return response.data
        } catch (error) {
            console.log(error)
            throw this.handleError(error)
        }
    }

    downloadFile(file) {
        const promisse = http.get(`/arquivo/${file.id}?empresa_id=${this.currentEmpresa.id}`, file)
        return promisse.then((response) => {
            const item = response.data
            return item || {}
        }).catch((error) => {
            console.log(error)
            throw this.handleError(error)
        });
    }

    async evolutionCodeTaxPdf(params) {
        const parameters = {
            date_ini: params.date_ini,
            date_end: params.date_end,
            empresa_id: this.currentEmpresa.id
        }

        try {
            const response = await http.get(`/atendimento/evolucao-codigo-fiscal/pdf`, {
                params: { ...parameters },
                responseType: "blob", // Recebe o PDF como um arquivo binário
            })
            const blob = new Blob([response.data], { type: "application/pdf" })
            const url = window.URL.createObjectURL(blob)
            window.open(url, "_blank") // Abre o PDF em uma nova aba
        } catch (error) {
            console.error("Erro ao gerar relatório de atendimentos:", error)
            throw this.handleError(error)
        }
    }

    async gerarRelatorioAtendimentos(params) {
        const parameters = {
            professionals: (params.professionals && Array.isArray(params.professionals)) ? params.professionals.map((professional) => professional.id) : null,
            pacients: (params.pacients) ? params.pacients.map((pacient) => pacient.id) : [],
            date_ini: params.date_ini,
            date_end: params.date_end,
            specialty_id: (params.specialty && params.specialty.id) ? params.specialty.id : null,
            empresa_id: this.currentEmpresa.id
        }

        try {
            const response = await http.get(`/atendimento/registro-evolucao/pdf`, {
                params: { ...parameters },
                responseType: "blob", // Recebe o PDF como um arquivo binário
            })
    
            const blob = new Blob([response.data], { type: "application/pdf" })
            const url = window.URL.createObjectURL(blob)
            window.open(url, "_blank"); // Abre o PDF em uma nova aba
        } catch (error) {
            console.error("Erro ao gerar relatório de atendimentos:", error)
            throw this.handleError(error)
        }
    }

    async gerarRelatorioAtendimentosProfessional(params) {
        console.log(params);
        const parameters = {
            pacients: (params.pacients) ? params.pacients.map((pacient) => pacient.id) : [],
            date_ini: params.date_ini,
            date_end: params.date_end,
            specialty_id: (params.specialty && params.specialty.id) ? params.specialty.id : null,
            empresa_id: this.currentEmpresa.id
        }

        try {
            const response = await http.get(`/atendimento/profissional/registro-evolucao/pdf`, {
                params: { ...parameters },
                responseType: "blob", // Recebe o PDF como um arquivo binário
            })
    
            const blob = new Blob([response.data], { type: "application/pdf" })
            const url = window.URL.createObjectURL(blob)
            window.open(url, "_blank"); // Abre o PDF em uma nova aba
        } catch (error) {
            console.error("Erro ao gerar relatório de atendimentos:", error)
            throw this.handleError(error)
        }
    }

    async getAtendimentosRepasseProfissional() {
        try {
            const response = await http.get(`/atendimento/calcularValorTotalRealizado?empresa_id=2`)
            return response
        } catch (error) {
            console.error("Erro ao gerar relatório de atendimentos:", error)
            throw this.handleError(error)
        }
    }
    
    async finishAtendimento(atendimentoId, finishData) {
        try {
            const payload = {
                atendimento: {
                    id: atendimentoId,
                    end_date: finishData.end_date,
                }
            }
            const response = await http.put(
                `/atendimento/${atendimentoId}/finish?empresa_id=${this.currentEmpresa?.id}`,
                payload
            )
            return response.data
        } catch (error) {
            console.error("Erro ao encerrar atendimento:", error)
            throw this.handleError(error)
        }
    }

    handleError(error) {
        let messageErro = ""

        // error.response
        if (error.response && error.response.data) {
            messageErro = error.response.data
        }

        switch (error.response ? error.response.status : null) {
            case 406:
                return 'Erro 406: ' + (messageErro)
            case 404:
                return 'Erro 404: endpoint não encontrado ou servidor fora do ar'
            default:
                return error.message
        }
    }
}
